export enum TaskStatus {
  OPEN = 'open',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled'
}

export enum TaskPriority {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high'
}

export interface User {
  id: number;
  username: string;
  full_name: string;
}

export interface PartyInfo {
  id: number;
  name: string;
  phone?: string | null;
}

export interface TeamInfo {
  id: number;
  name: string;
}

export interface Task {
  id: number;
  organization_id: number;
  site_id: number | null;
  title: string;
  description: string | null;
  parent_entity_type: string;
  parent_entity_id: number;
  related_entity_type: string | null;
  related_entity_id: number | null;
  status: TaskStatus;
  priority: TaskPriority;
  task_category: string | null;
  task_type: string | null;
  due_date: string | null;
  assigned_to_user_id: number | null;
  team_id: number | null;
  created_by_user_id: number;
  completed_at: string | null;
  created_at: string;
  updated_at: string | null;
  assigned_to?: User;
  creator?: User;
  team?: TeamInfo;
  party?: PartyInfo; // Party data when parent_entity_type is 'party'
}

export interface TaskCreate {
  title: string;
  description?: string;
  parent_entity_type?: string;
  parent_entity_id?: number;
  related_entity_type?: string | null;
  related_entity_id?: number | null;
  status?: TaskStatus;
  priority?: TaskPriority;
  task_category?: string;
  task_type?: string;
  due_date?: string;
  assigned_to_user_id?: number;
  team_id?: number | null;
  site_id?: number;
}

export interface TaskUpdate {
  title?: string;
  description?: string;
  status?: TaskStatus;
  priority?: TaskPriority;
  task_category?: string;
  task_type?: string;
  due_date?: string;
  assigned_to_user_id?: number;
  team_id?: number | null;
  parent_entity_type?: string | null;
  parent_entity_id?: number | null;
  site_id?: number;
}

export interface TaskFilters {
  parent_entity_type?: string;
  parent_entity_id?: number;
  related_entity_type?: string;
  related_entity_id?: number;
  assigned_to_user_id?: number;
  team_id?: number;
  unassigned_in_my_teams?: boolean;
  status?: TaskStatus;
  priority?: TaskPriority;
  task_category?: string;
  task_type?: string;
  due_date_from?: string;
  due_date_to?: string;
  site_id?: number;
  search?: string;
}

export interface TaskListResponse {
  items: Task[];
  total: number;
}

export interface EntityReference {
  type: string;
  id: number;
}